import { Assert } from '@cotera/utilities';
import { resourceViewOfItem } from '@cotera/sdk/core';
import type { FolderScope } from '../resources/list/resource-list-types';
import type { FolderContentItem } from './folder-contents-page.model';

export function getFolderContentItemFolderScope(
  item: FolderContentItem,
  fallbackScope: FolderScope | null
): FolderScope | null {
  switch (item.type) {
    case 'folder':
      return item.data.scope;
    case 'chat':
    case 'agent':
    case 'document':
    case 'workflow':
    case 'dataset':
    case 'workflow_trigger': {
      const fs = item.data.folderScope;
      if (fs === undefined || fs === null) {
        return fallbackScope;
      }
      return fs;
    }
    default:
      return Assert.unreachable(item);
  }
}

export function getItemDisplayName(item: FolderContentItem): string {
  return resourceViewOfItem(item).title();
}
